function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import PropTypes from "prop-types";
import StyledSidebarHeader from "./sidebar-header.style";
const SidebarHeader = ({
  children,
  id,
  closeIcon,
  ...rest
}) => /*#__PURE__*/React.createElement(StyledSidebarHeader, _extends({
  hasClose: !!closeIcon,
  id: id,
  "data-component": "sidebar-header",
  p: "27px 32px 32px"
}, rest), children, closeIcon);
SidebarHeader.displayName = "SidebarHeader";
export default SidebarHeader;